import React, { useState } from 'react';
import { List, Typography } from "@mui/material";
import InventoryCategories from '../../components/inventory/modals/InventoryCategories';
import InventoryTransactionTypes from '../../components/inventory/modals/InventoryTransactionTypes';
import InventorySuppliers from '../../components/inventory/modals/InventorySuppliers';
import InventoryItems from '../../components/inventory/modals/InventoryItems';
import InventoryTransactions from '../../components/inventory/modals/InventoryTransactions';
import Bundles from '../../components/inventory/modals/Bundles';

const InventoryPage = () => {
    // const [type, setType] = useState([]);

    return (
        <>
            <Typography variant="h4">Inventory</Typography>
            <List>
                <InventoryItems />
                <Bundles />
                <InventoryTransactions />
                <InventorySuppliers />
                <InventoryCategories />
                <InventoryTransactionTypes />
            </List>
        </>
    );
};

export default InventoryPage;
